/* eslint-disable */
import * as React from 'react';
const SvgDealerCheckIcon = (props) => (React.createElement("svg", { viewBox: "0 0 160 160", width: "1em", height: "1em", ...props },
    React.createElement("path", { d: "M80 0C35.8 0 0 35.8 0 80s35.8 80 80 80 80-35.8 80-80S124.2 0 80 0zm43.3 59.6L71 111.9c-3.1 3.1-8.2 3.1-11.4 0L36.7 89c-3.2-3.2-3.2-8.3 0-11.4 3.1-3.1 8.2-3.1 11.4 0l17.1 17.1 46.6-46.6c3.1-3.1 8.2-3.1 11.4 0 3.2 3.2 3.2 8.3.1 11.5z" })));
export default SvgDealerCheckIcon;
/* eslint-enable */
